var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('ul',_vm._l((_vm.MoMoLinkList),function(item,index){return _c('li',{key:index},[_c('a',{attrs:{"href":item.link}},[_vm._v(_vm._s(index + 1)+". "+_vm._s(item.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }